import { VideoResolution } from "../__generated__/globalTypes";
import { VIDEO_QUALITY_THRESHOLDS } from "./constants";

/**
 * Determines the optimal video quality based on bandwidth
 * Modern mobile devices can handle high quality video streaming
 * @param bandwidthMbps - Current bandwidth in Mbps
 * @param availableQualities - Array of available video qualities
 * @returns The optimal VideoResolution for the given bandwidth
 */
export function determineOptimalQuality(bandwidthMbps: number, availableQualities: VideoResolution[]): VideoResolution {
  // Sort qualities from highest to lowest for proper selection
  const qualityOrder: VideoResolution[] = [VideoResolution.FHD, VideoResolution.HD, VideoResolution.SD];

  // Find the highest quality that can be supported by the current bandwidth
  for (const quality of qualityOrder) {
    if (availableQualities.includes(quality)) {
      const threshold = VIDEO_QUALITY_THRESHOLDS[quality as keyof typeof VIDEO_QUALITY_THRESHOLDS] || 0;
      if (bandwidthMbps >= threshold) {
        return quality;
      }
    }
  }

  // Fallback to lowest available quality
  return availableQualities[0] || VideoResolution.SD;
}
